import LandingFooter from '@/components/LandingFooter.tsx'
import LandingHeader from '@/components/LandingHeader.tsx'
import { languageBasedOnTimezone } from '@/utils/language.ts'
import { useEffect } from 'react'
import styles from './PolicyPage.module.scss'

export const SecurityMeasuresPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <div className={styles.policyContainer}>
        <div className={styles.topSection}>
          <LandingHeader language={languageBasedOnTimezone()} selectLanguageEnabled={false} />
        </div>
        <div className={styles.contentsSection}>
          <div className={styles.titleContainer}>
            <h1>Tracker Boot Security Measures</h1>
            <div className={styles.dates}>Effective Date: April 24, 2025</div>
            <div className={styles.dates}>Last Updated: April 24, 2025</div>
            <div>
              <p>
                At Bekind Labs, we are committed to protecting the security, confidentiality, and integrity of your
                data. We implement a layered security approach that includes both technical and organizational controls.
                Below are the key security measures in place for Tracker Boot:
              </p>
            </div>
          </div>
          <div className={styles.contentsContainer}>
            <h2>Web Application Security</h2>
            <p>
              Tracker Boot is protected by Amazon Web Application Firewall (WAF) with multiple layers of filtering,
              including:
            </p>
            <ul>
              <li>• OWASP Top 10 protections (e.g., injection, cross-site scripting, broken authentication)</li>
              <li>• Maximum body size limit rule (custom) to prevent oversized payload attacks</li>
              <li>• File upload size limit rule (custom) to block abnormally large files</li>
              <li>• Rate limiting rule (custom) to mitigate denial-of-service (DoS) and brute-force attacks</li>
              <li>• SQL injection protection rule (custom) to detect and block malicious input targeting databases</li>
            </ul>
          </div>
          <div className={styles.contentsContainer}>
            <h2>Authentication and Session Management</h2>
            <ul>
              <li>• Authentication and Session Management</li>
              <li>
                • SSO Login (Google) is enforced to streamline authentication and reduce credential-based attack risks
              </li>
              <li>
                • Once authenticated, Tracker Boot uses secure session cookies to maintain login status, reducing the
                need for repeated authentication and minimizing exposure of login credentials
              </li>
            </ul>
          </div>
          <div className={styles.contentsContainer}>
            <h2>Organizational Controls</h2>
            <ul>
              <li>• Role-based access control (RBAC) within the Tracker Boot environment</li>
              <li>• Continuous monitoring for abnormal activity</li>
              <li>• Encrypted data in transit (TLS) and at rest</li>
              <li>• Regular internal audits and security reviews</li>
            </ul>
          </div>
          <div className={styles.contentsContainer}>
            <h2>Third-Party Dependencies</h2>
            <p>
              Tracker Boot relies on a number of trusted third-party open-source libraries and services. A complete and
              up-to-date list of current dependencies is available
              <a href="https://trackerboot.com/dependencies.html">&nbsp;here</a>.
            </p>
            <p>
              These measures reflect our commitment to maintaining a secure environment for your product development
              workflows.
            </p>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  )
}
